export const financialTypeOptions = [
  { label: 'All', value: null },
  { label: 'Cash-to-Cash', value: 'C-C' },
  { label: 'Mortgage-to-Cash', value: 'M-C' },
  { label: 'Cash-to-Mortgage', value: 'C-M' },
  { label: 'Mortgage-to-Mortgage', value: 'M-M' }
];
